import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "results" }
const _hoisted_2 = { class: "section-title large" }
const _hoisted_3 = {
  key: 0,
  class: "description"
}
const _hoisted_4 = { class: "filter-tabs" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "filter-content" }
const _hoisted_7 = {
  key: 0,
  class: "date-filter"
}
const _hoisted_8 = {
  key: 1,
  class: "game-filter"
}
const _hoisted_9 = {
  key: 2,
  class: "draw-filter"
}
const _hoisted_10 = ["value", "placeholder"]
const _hoisted_11 = {
  key: 1,
  class: "results-skeleton-grid",
  "aria-busy": "true",
  "aria-live": "polite"
}
const _hoisted_12 = { class: "results-skeleton-balls" }
const _hoisted_13 = {
  key: 2,
  class: "results-status results-status--error"
}
const _hoisted_14 = {
  key: 3,
  class: "empty-state"
}
const _hoisted_15 = {
  key: 4,
  class: "results-grid"
}
const _hoisted_16 = {
  key: 5,
  class: "load-more"
}
const _hoisted_17 = ["disabled"]

import { ref, computed, watch, onMounted } from 'vue'

import { useI18n } from 'vue-i18n'
import LotteryResultCard from '@/components/LotteryResultCard.vue'
import NextDrawsFilter from '@/components/NextDrawsFilter.vue'
import { useResultsStore } from '@/stores/results'
import { useGameStore } from '@/stores/game'
import { useRouter, useRoute } from 'vue-router'
import CustomSelect from '@/components/base/CustomSelect.vue'
import { useIntegrationMode } from '@/composables/useIntegrationMode'
// import { useAuthStore } from '@/stores/auth'

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ResultsView'
},
  __name: 'ResultsView',
  setup(__props) {



const gameStore = useGameStore()
const resultsStore = useResultsStore();
// const authStore = useAuthStore()
const router = useRouter()
const route = useRoute()
const { isLite } = useIntegrationMode()
const { t } = useI18n()

const tabs = computed(() => [
  { id: 'by-date', label: t('results.byDate') },
  { id: 'by-lottery', label: t('results.byGame') },
  { id: 'by-drawid', label: t('results.byDrawId') }
]);

const activeTab = ref('by-lottery'); // Default to BY GAME
const selectedDate = ref('');
const selectedGame = ref('');
const drawId = ref('');

const handleDrawIdInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const digitsOnly = input.value.replace(/\D/g, '');
  if (input.value !== digitsOnly) {
    input.value = digitsOnly;
  }
  drawId.value = digitsOnly;
};

const buildFilters = () => {
  const filters: Record<string, string> = {};

  if (activeTab.value === 'by-date') {
    filters.drawType = 'by-date';
    if (selectedDate.value) {
      filters.drawDate = selectedDate.value;
    }
  } else if (activeTab.value === 'by-lottery') {
    filters.drawType = 'by-lottery';
    if (selectedGame.value) {
      filters.gameSlug = selectedGame.value;
    }
  } else if (activeTab.value === 'by-drawid') {
    filters.drawType = 'draw';
    if (drawId.value.trim()) {
      filters.drawId = drawId.value.trim();
    }
  }

  return filters;
};

const refreshResults = () => {
  resultsStore.setFilters(buildFilters());
  resultsStore.fetchResults(1);
};

const loadMore = async () => {
  await resultsStore.loadMoreResults();
};

const handleDateFilter = (date: string) => {
  selectedDate.value = date;
};

const handleBet = async (game: any) => {
  await gameStore.fetchGameDetails(game.game_slug)
  router.push({ path: `/lottery/${game?.game_slug}`, query: route.query })
}

const gamesList = computed(() => {
  // Use game store to show ALL games, not just games with results
  const allGames = gameStore.getProducts || [];
  if (!Array.isArray(allGames)) return [];
  
  // Sort games alphabetically by name and map to { label, value }
  return [...allGames]
    .sort((a, b) => {
      const nameA = a.name?.toLowerCase() || '';
      const nameB = b.name?.toLowerCase() || '';
      return nameA.localeCompare(nameB);
    })
    .map(g => ({
      label: g.name,
      value: g.slug
    }));
});

watch(activeTab, async (newTab, oldTab) => {
  if (oldTab === 'by-lottery' && newTab !== 'by-lottery') {
    selectedGame.value = '';
  }
  if (isLite.value && newTab === 'by-lottery' && (!gameStore.getProducts || gameStore.getProducts.length === 0)) {
    await gameStore.fetchProducts();
  }
});

watch(
  [activeTab, selectedDate, selectedGame, drawId],
  () => {
    refreshResults();
  }
);

onMounted(async () => {
  if (!isLite.value && (!gameStore.getProducts || gameStore.getProducts.length === 0)) {
    await gameStore.fetchProducts();
  }
  refreshResults();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('results.title')), 1),
    (!_unref(isLite))
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('results.description')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab.id,
          class: _normalizeClass(["tab-button", { active: activeTab.value === tab.id }]),
          onClick: ($event: any) => (activeTab.value = tab.id)
        }, _toDisplayString(tab.label), 11, _hoisted_5))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (activeTab.value === 'by-date')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(NextDrawsFilter, {
              modelValue: selectedDate.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                handleDateFilter
              ],
              "allow-past": true,
              placeholder: _ctx.$t('results.selectDate'),
              "fallback-to-today": false,
              "no-interaction-highlight": ""
            }, null, 8, ["modelValue", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'by-lottery')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(CustomSelect, {
              modelValue: selectedGame.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedGame).value = $event)),
              options: gamesList.value,
              placeholder: _ctx.$t('results.allGames')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'by-drawid')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("input", {
              value: drawId.value,
              type: "text",
              inputmode: "numeric",
              pattern: "[0-9]*",
              autocomplete: "off",
              "data-keyboard": "numeric",
              placeholder: _ctx.$t('results.enterDrawId'),
              class: "draw-input",
              onInput: handleDrawIdInput
            }, null, 40, _hoisted_10)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(resultsStore).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
            return _createElementVNode("div", {
              key: 'skeleton-' + n,
              class: "results-skeleton-card"
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "results-skeleton-line results-skeleton-line--title" }, null, -1)),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "results-skeleton-line results-skeleton-line--meta" }, null, -1)),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (ball) => {
                  return _createElementVNode("span", {
                    key: 'ball-' + n + '-' + ball,
                    class: "results-skeleton-ball"
                  })
                }), 64))
              ])
            ])
          }), 64))
        ]))
      : (_unref(resultsStore).error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(resultsStore).error), 1))
        : (!_unref(resultsStore).results.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('results.noDataAvailable')), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultsStore).results, (result) => {
                return (_openBlock(), _createBlock(LotteryResultCard, {
                  key: result.id,
                  lottery: result,
                  onBet: ($event: any) => (handleBet(result))
                }, null, 8, ["lottery", "onBet"]))
              }), 128))
            ])),
    (_unref(resultsStore).hasMorePages)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "load-more-button",
            disabled: _unref(resultsStore).loadingMore,
            onClick: loadMore
          }, _toDisplayString(_unref(resultsStore).loadingMore ? _ctx.$t('common.loading') : _ctx.$t('results.loadMore')), 9, _hoisted_17)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})